<template>
  <div>
    <el-dialog :visible="visible" title="导入手机号" width="1180px" :before-close="handleClose">
      <div class="topTis">
        <i class="el-icon-warning" style="color: #FE8F8A; marginRight: 8px;  font-size: 14px"></i>
        <div class="desc">
          <p>温馨提示：</p>
          <p>1.直接上传所需发送的号码文件，如选择之前已上传过的历史文件，可直接在列表选中确认即可。</p>
          <p>2.文件上传处理状态显示“完成”即可选择此文件，进入下一步操作。</p>
          <p>3.如上传文件含有变量，则可选择变量加入到短信内容，不需要可不选择。</p>
        </div>
      </div>
      <div style="margin-bottom: 20px">
        <el-upload 
          action=""
          ref="upload"
          :show-file-list="false"
          :on-success="handleSuccess"
          :limit="1"
          accept=".csv, .txt, .xls, .xlsx"
          :before-upload="beforeUpload"
         >
        <el-button :style="{'color': globalBG, 'border-color': globalBG}">上传文件</el-button>
        </el-upload>
      </div>
      <div class="search-box">
        <el-form ref="formSearch" :inline="true" :model="form" label-width="100px">
          <el-form-item label="文件名:">
            <el-input placeholder="请输入文件名" v-model="form.fileOldName"></el-input>
          </el-form-item>
          <el-form-item label="上传状态:">
            <el-select size="small" v-model="form.state">
              <el-option
                v-for="(item, index) in stateList"
                :key="index"
                :value="item.value"
                :label="item.label"
              ></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="上传时间:">
            <div class="my_select_time">
              <el-date-picker
                prefix-icon="no_icon"
                v-model="form.startTime"
                type="datetime"
                placeholder="开始日期"
                size="small"
                format="yyyy-MM-dd HH:mm:ss"
                value-format="yyyy-MM-dd HH:mm:ss"
                style="width: 120px;font-size:12px"
                class="time1"
                :clearable="false"
                @change="moneyPayTimeChange"
              ></el-date-picker>
              <div class="time_to_text">至</div>
              <el-date-picker
                prefix-icon="no_icon"
                v-model="form.endTime"
                type="datetime"
                placeholder="结束日期"
                size="small"
                format="yyyy-MM-dd HH:mm:ss"
                value-format="yyyy-MM-dd HH:mm:ss"
                style="width: 145px;font-size:12px"
                class="time2"
                :clearable="false"
                @change="moneyPayTimeChange"
              ></el-date-picker>
              <i class="el-icon-circle-close date_icon1" @click="clearTime"></i>
              <img src="@/assets/images/select_date.svg" alt class="date_icon2" />
            </div>
          </el-form-item>

          <div class="button-group">
            <el-button size="small" class="search" type="primary" @click="submitForm('formSearch')">
              <i
                class="el-icon-search"
                style="display:inline-block;width:14px;height:12px;"
              ></i> 查询
            </el-button>
            <el-button size="small" class="reset" type="primary" @click="resetForm">重置</el-button>
          </div>
        </el-form>
        <div class="">
          <el-table
            ref="table"
            class="table-box"
            v-loading="tableLoading"
            :data="tableData"
            tooltip-effect="light"
            style="width: 100%; border: 1px solid #eee"
          >
            <el-table-column type="index" label="序号"></el-table-column>
            <el-table-column label="文件名" prop="fileOldName"></el-table-column>
            <el-table-column label="记录数" prop="totalMobile">
            </el-table-column>
            <el-table-column label="处理状态">
              <template slot-scope="scope">
                <span v-if="scope.row.state == '1'">执行中</span>
                <span v-if="scope.row.state == '2'">完成</span>
                <span v-if="scope.row.state == '3'">上传失败</span>
              </template>
            </el-table-column>
            <el-table-column label="完成时间" prop="endTime"></el-table-column>
            <el-table-column label="操作">
              <template slot-scope="scope">
                <el-button v-if="scope.row.state == '2'" type="text"  class="Notetake"  @click="handleImport(scope.row, scope.$index)">导入</el-button>
                <el-button v-else type="text" style="width:60px;color:#666666">导入</el-button>
                <el-button
                  type="text"
                  @click="handleDelete(scope.row, scope.$index)"
                  class="Notetake"
                >删除</el-button>
              </template>
            </el-table-column>
          </el-table>
          <!-- 分页器 -->
          <div>
            <el-pagination
              background
              style="text-align: right; margin-top: 20px;"
              @size-change="handleSizeChange"
              @current-change="handleCurrentChange"
              :current-page="form.current"
              :page-sizes="[10, 20, 30, 50, 100, 500]"
              :page-size="form.size"
              layout="total, sizes, prev, pager, next, jumper"
              :total="total"
            ></el-pagination>
          </div>
        </div>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { getUploadList, deleteById, uploadMobile } from "@/api/uploadFile.js";
import { mapState } from "vuex";
export default {
  /** 短信记录弹窗 */
  name: "sms-record",
  props: {
    visible: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    ...mapState({
      globalBG: "globalBG",
    }),
  },
  data() {
    return {
      // visible: true,
      form: {
        fileOldName: "",
        state: "",
        startTime: "",
        endTime: "",
        current: 1,
        size: 10,
      },

      stateList: [
        {
          label: "全部",
          value: "",
        },
        {
          label: "执行中",
          value: 1,
        },
        {
          label: "完成",
          value: 2,
        },
        {
          label: "上传出错",
          value: 3,
        },
      ],
      tableData: [],
      total: 0,
      tableLoading: false,
    };
  },
  mounted() {
    this.getDataList();
  },
  methods: {
    handleSuccess() {
      // console.log(res,file);
      // this.fileUrl = URL.createObjectURL(file.raw);
      this.$message.success("文件上传成功");
    },

    beforeUpload(file) {
      const fileSize = file.size / 1024 / 1024 < 50;
      if (!fileSize) {
        this.message.warning("上传模板大小不能超过 50MB!");
        return  false;
      }
      console.log('file', file)
      let formData=new FormData();
      formData.append('file', file);
      console.log('formData:', formData);
      uploadMobile(formData).then(res => {
        console.log(res)
        if (res.code == '1') {
          this.$message.success('上传成功！')
          this.getDataList();
        }else {
          this.$message.error(res.message);
        }
      })
      return false;
    },
    handleClose() {
      var obj = {flag: false} // flag: false， 表示取消关闭弹窗
      this.$emit('onClose', obj);
    },
    handleImport(row, index) {
      var obj = {flag: true} // flag: false， 导入关闭弹窗
      Object.assign(obj, row)
      this.$emit('onClose', obj);
    },
    handleDelete(row, index) {
      this.$confirm("确定要删除吗?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        iconClass:"iconfont iconicon-jinggao1",
      })
        .then(() => {
          var fid = row.fid;
          deleteById(fid).then((res) => {
            if (res.code == "1") {
              this.$message.success("删除成功！");
              this.getDataList();
            } else {
              this.$message.error(res.message);
            }
          });
        })
        .catch(() => {
          this.$message.info("已取消删除");
        });
    },
    getDataList() {
      this.tableLoading = true;
      getUploadList(this.form).then((res) => {
        this.tableLoading = false;
        if (res.code == "1") {
          this.tableData = res.data.records;
          this.total = +res.data.total;
        }
      });
    },
    clearTime() {
      this.form.startTime = "";
      this.form.endTime = "";
    },
    moneyPayTimeChange() {},
    submitForm() {
      this.getDataList();
    },
    resetForm() {
      this.form = {
        fileOldName: "",
        state: "",
        startTime: "",
        endTime: "",
        current: 1,
        size: 10,
      };
      this.getDataList();
    },
    handleSizeChange(val) {
      this.form.size = val;
      this.getDataList();
    },
    handleCurrentChange(val) {
      this.form.current = val;
      this.getDataList();
    },
  },
};
</script>

<style lang="scss" scoped>
.table-box{
  max-height: 400px;
  overflow: auto;
    .Notetake {
      width: 60px;
    cursor: pointer;
    color: #7f85e9;
    &:hover {
      color: #fe4d45;
    }
  }
}
.topTis {
  display: flex;
  align-items: baseline;
  // margin: 0 30px 30px 56px;
  // margin-top: 24px;
  color: #333;
  font-size: 14px;

  background: #fafafa;
  opacity: 1;
  margin: 0px;
  padding: 12px;
  margin-bottom: 20px;
  color: #333;
  .desc {
    line-height: 20px;
    .setting-text {
      margin-bottom: 8px;
      span {
        font-size: 14px;
        color: #fe4d45;
        margin-left: 30px;
      }
    }
  }
  p {
    margin: 0px;
    line-height: 20px;
    // width: 700px;
  }
}
.search-box {
  .el-input,
  .el-select {
    width: 136px;
  }
  .button-group {
    display: inline-block;
    text-align: center;
    margin-bottom: 20px;
    margin-left: 30px;
    .search{
      width: 98px;
      height: 32px;
      color: #fe4d45;
      border: 1px solid #fe4d45 ;
      background-color: #fff;
   &:hover{
      color: #fff ;
      border: 1px solid #fff;
      background-color: #fe4d45;
    }
}.reset{
      width: 98px;
      height: 32px;
      color: #666666;
      border: 1px solid #dddddd;
      background-color: #fff;
    &:hover{
      color:#fe4d45 ;
      border: 1px solid #fe4d45;
      background-color: #FFF4F4;
    }
}
  }
}
</style>
